(function() {
  'use strict';

  var TOKEN_KEY = 'faima_follow_session_token_v1';
  var API = 'https://panel.faimainstant.ro/api/faima/gifts';
  var TASK_API = 'https://panel.faimainstant.ro/api/faima/follow-credits';

  function ensureGiftStylesheet() {
    var source = document.querySelector('link[href*="faima-gifts.css"]');
    if (!source || document.head.querySelector('link[href="' + source.href + '"]')) return;
    var stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = source.href;
    stylesheet.media = 'all';
    document.head.appendChild(stylesheet);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function(character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function request(url, body) {
    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(response) {
      return response.json().catch(function() { return {}; }).then(function(payload) {
        if (!response.ok || payload.ok === false) {
          var error = new Error(payload.error || 'Serviciul este temporar indisponibil.');
          error.code = payload.code || '';
          error.status = response.status;
          throw error;
        }
        return payload;
      });
    });
  }

  function readToken() {
    try { return String(window.localStorage.getItem(TOKEN_KEY) || ''); } catch (error) { return ''; }
  }

  function writeToken(token) {
    if (!token) return;
    try { window.localStorage.setItem(TOKEN_KEY, token); } catch (error) {}
    document.cookie = TOKEN_KEY + '=' + encodeURIComponent(token) + '; path=/; max-age=31536000; samesite=lax; secure';
  }

  function ensureToken() {
    var current = readToken();
    return request(TASK_API, { action: 'state', token: current, tokenCandidates: current ? [current] : [], market: 'ro' })
      .then(function(payload) {
        var token = String(payload.token || current || '');
        writeToken(token);
        return token;
      });
  }

  function isCompleted(status) {
    return ['payment_verified', 'queued_tasks', 'sent', 'awarded', 'active', 'submission_uncertain'].indexOf(status) >= 0;
  }

  function targetCopy(card) {
    if (card.rewardType === 'likes') return {
      label: 'Link postare sau Reel Instagram',
      placeholder: 'https://www.instagram.com/p/.../'
    };
    return {
      label: 'Link profil Instagram',
      placeholder: 'https://www.instagram.com/profil/'
    };
  }

  function GiftBar(root) {
    this.root = root;
    this.selector = root.querySelector('[data-service-selector]');
    this.token = '';
    this.state = null;
    this.busy = false;
    this.openCode = '';
    if (!this.selector) return;
    this.mount();
  }

  GiftBar.prototype.mount = function() {
    var self = this;
    this.element = document.createElement('section');
    this.element.className = 'faima-gifts';
    this.element.setAttribute('aria-labelledby', 'faima-gifts-title');
    this.element.innerHTML = '<div class="faima-gifts-loading" role="status">Pregătim cadourile tale…</div>';
    this.selector.insertBefore(this.element, this.selector.firstChild);
    this.hall = document.createElement('section');
    this.hall.className = 'faima-hall-of-fame';
    this.hall.hidden = true;
    this.root.appendChild(this.hall);
    this.element.addEventListener('click', function(event) {
      var scrollButton = event.target.closest('[data-gifts-scroll]');
      if (scrollButton) {
        self.scrollGifts(Number(scrollButton.getAttribute('data-gifts-scroll')) || 1);
        return;
      }
      var action = event.target.closest('[data-gift-action]');
      if (!action || action.disabled || self.busy) return;
      var code = action.getAttribute('data-gift-action');
      var card = self.state && self.state.cards.find(function(item) { return item.code === code; });
      if (!card) return;
      if (self.openCode === code || ['discount', 'next_order_bonus'].indexOf(card.kind) >= 0) {
        self.claim(card);
      } else {
        self.openCode = code;
        self.render();
        window.setTimeout(function() {
          var input = self.element.querySelector('[data-gift-target="' + code + '"]');
          if (input) input.focus();
        }, 0);
      }
    });
    this.element.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter') return;
      var input = event.target.closest('[data-gift-target]');
      if (!input) return;
      var card = self.state.cards.find(function(item) { return item.code === input.getAttribute('data-gift-target'); });
      if (card) self.claim(card);
    });
    ensureToken().then(function(token) {
      self.token = token;
      return self.load();
    }).catch(function(error) {
      self.element.innerHTML = '<p class="faima-gifts-error" role="alert">' + escapeHtml(error.message) + '</p>';
    });
  };

  GiftBar.prototype.load = function() {
    var self = this;
    return request(API, { action: 'state', token: this.token }).then(function(payload) {
      self.state = payload;
      self.render();
      self.renderHall();
      request(API, { action: 'event', token: self.token, eventType: 'bar_viewed' }).catch(function() {});
    });
  };

  GiftBar.prototype.claimMap = function() {
    var map = {};
    (this.state.claims || []).forEach(function(claim) { map[claim.cardCode] = claim; });
    return map;
  };

  GiftBar.prototype.render = function() {
    var self = this;
    var claims = this.claimMap();
    var visible = this.state.cards.filter(function(card) {
      var claim = claims[card.code];
      return card.persistent || !claim || !isCompleted(claim.status);
    });
    var html = '' +
      '<header class="faima-gifts-header">' +
        '<span class="faima-gifts-heading"><span aria-hidden="true">🎁</span><strong id="faima-gifts-title">Cadouri!</strong></span>' +
        '<span class="faima-gifts-controls">' +
          '<button type="button" class="faima-gifts-arrow" data-gifts-scroll="-1" aria-label="Cadourile anterioare">‹</button>' +
          '<span class="faima-gifts-progress" data-gifts-progress aria-live="polite">1–' + Math.min(4, visible.length) + ' / ' + visible.length + '</span>' +
          '<button type="button" class="faima-gifts-arrow" data-gifts-scroll="1" aria-label="Cadourile următoare">›</button>' +
        '</span>' +
      '</header>' +
      '<div class="faima-gifts-grid">';
    visible.forEach(function(card) {
      var claim = claims[card.code];
      var completed = claim && isCompleted(claim.status);
      var active = Number(card.position) === Number(self.state.currentPosition) || (card.persistent && completed);
      var locked = !active;
      var classes = ['faima-gift-card'];
      if (card.kind === 'paid') classes.push('is-paid');
      if (card.kind === 'daily') classes.push('is-daily');
      if (card.kind === 'legend') classes.push('is-legend');
      if (String(card.code).indexOf('spin_') === 0) classes.push('is-spin');
      if (String(card.code).indexOf('mystery_') === 0) classes.push('is-mystery');
      if (locked) classes.push('is-locked');
      if (active) classes.push('is-active');
      var displaySubtitle = String(card.subtitle || '');
      var buttonText = card.kind === 'daily' && completed ? (self.state.dailyClaimedToday ? 'Revino mâine' : 'Revendică azi') : 'Gratuit';
      if (card.kind === 'paid') {
        var paidPriceCents = Number(card.priceCents || 0);
        var paidPriceMatch = displaySubtitle.match(/(\d+(?:[.,]\d{2}))\s*RON/i);
        buttonText = paidPriceCents > 0
          ? (paidPriceCents / 100).toFixed(2) + ' RON'
          : (paidPriceMatch ? paidPriceMatch[1].replace(',', '.') + ' RON' : 'RON');
        displaySubtitle = displaySubtitle.replace(/\s*[·•-]?\s*\d+(?:[.,]\d{2})\s*RON\s*$/i, '').trim();
      }
      if (card.kind === 'referral') buttonText = 'Invită · ' + Number(self.state.referralProgress || 0) + '/3';
      if (card.kind === 'follow') buttonText = 'Verifică task-ul';
      html += '<article class="' + classes.join(' ') + '">' +
        '<span class="faima-gift-step">' + card.position + '</span>' +
        (card.badge ? '<span class="faima-gift-badge">' + escapeHtml(card.badge) + '</span>' : '') +
        '<strong class="faima-gift-number">' + escapeHtml(card.title) + '</strong>' +
        '<span class="faima-gift-label">' + escapeHtml(displaySubtitle) + '</span>' +
        '<span class="faima-gift-emoji" aria-hidden="true">' + escapeHtml(card.emoji) + '</span>' +
        '<button type="button" class="faima-gift-button" data-gift-action="' + escapeHtml(card.code) + '" ' + (locked || (card.kind === 'daily' && completed && self.state.dailyClaimedToday) ? 'disabled' : '') + '>' + escapeHtml(buttonText) + '</button>';
      if (self.openCode === card.code && active && ['discount', 'next_order_bonus'].indexOf(card.kind) < 0) {
        var copy = targetCopy(card);
        html += '<div class="faima-gift-target-panel">' +
          '<label><span>' + escapeHtml(copy.label) + '</span><span class="faima-gift-target-row">' +
            '<input type="url" inputmode="url" autocomplete="url" placeholder="' + escapeHtml(copy.placeholder) + '" data-gift-target="' + escapeHtml(card.code) + '">' +
            '<button type="button" data-gift-action="' + escapeHtml(card.code) + '" aria-label="Revendică acest cadou">›</button>' +
          '</span></label>' +
          (card.kind === 'legend' ? '<label class="faima-gift-consent"><input type="checkbox" data-gift-hall-consent> Sunt de acord ca username-ul să apară în Hall of Fame.</label>' : '') +
          '<p class="faima-gift-inline-status" data-gift-status="' + escapeHtml(card.code) + '" role="status"></p>' +
        '</div>';
      }
      html += '</article>';
    });
    html += '</div>';
    this.element.innerHTML = html;
    var grid = this.element.querySelector('.faima-gifts-grid');
    if (grid) {
      var ticking = false;
      grid.addEventListener('scroll', function() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function() {
          self.updateProgress();
          ticking = false;
        });
      }, { passive: true });
      this.updateProgress();
    }
  };

  GiftBar.prototype.scrollGifts = function(direction) {
    var grid = this.element.querySelector('.faima-gifts-grid');
    if (!grid) return;
    grid.scrollBy({ left: direction * Math.max(220, grid.clientWidth * 0.92), behavior: 'smooth' });
  };

  GiftBar.prototype.updateProgress = function() {
    var grid = this.element.querySelector('.faima-gifts-grid');
    var progress = this.element.querySelector('[data-gifts-progress]');
    if (!grid || !progress) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.faima-gift-card'));
    if (!cards.length) {
      progress.textContent = '0 / 0';
      return;
    }
    var first = 0;
    var viewportLeft = grid.scrollLeft + 2;
    for (var index = 0; index < cards.length; index += 1) {
      if (cards[index].offsetLeft <= viewportLeft) first = index;
      else break;
    }
    var visibleCount = Math.max(1, Math.round(grid.clientWidth / Math.max(1, cards[0].offsetWidth)));
    progress.textContent = (first + 1) + '–' + Math.min(cards.length, first + visibleCount) + ' / ' + cards.length;
  };

  GiftBar.prototype.claim = function(card) {
    var self = this;
    if (this.busy) return;
    var input = this.element.querySelector('[data-gift-target="' + card.code + '"]');
    var target = input ? input.value.trim() : '';
    var consent = Boolean(this.element.querySelector('[data-gift-hall-consent]:checked'));
    var status = this.element.querySelector('[data-gift-status="' + card.code + '"]');
    this.busy = true;
    if (status) status.textContent = card.kind === 'paid' ? 'Pregătim plata securizată…' : 'Revendicăm cadoul…';
    request(API, { action: 'claim', token: this.token, cardCode: card.code, target: target, hallConsent: consent })
      .then(function(payload) {
        if (payload.checkoutUrl) {
          window.location.assign(payload.checkoutUrl);
          return;
        }
        self.celebrate(payload.rewardCode || 'Cadoul a fost revendicat!');
        self.openCode = '';
        return self.load();
      })
      .catch(function(error) {
        if (status) status.textContent = error.message;
        else self.announce(error.message, true);
      })
      .finally(function() { self.busy = false; });
  };

  GiftBar.prototype.announce = function(message, error) {
    var popup = document.createElement('div');
    popup.className = 'faima-gift-popup' + (error ? ' is-error' : '');
    popup.setAttribute('role', error ? 'alert' : 'status');
    popup.innerHTML = '<button type="button" aria-label="Închide">×</button><span aria-hidden="true">' + (error ? '⚠️' : '🎉') + '</span><strong>' + escapeHtml(error ? 'Nu am putut continua' : 'Felicitări!') + '</strong><p>' + escapeHtml(message) + '</p>';
    popup.querySelector('button').addEventListener('click', function() { popup.remove(); });
    document.body.appendChild(popup);
    window.setTimeout(function() { if (popup.isConnected) popup.remove(); }, 6500);
  };

  GiftBar.prototype.celebrate = function(detail) {
    var layer = document.createElement('div');
    layer.className = 'faima-gift-confetti';
    layer.setAttribute('aria-hidden', 'true');
    for (var index = 0; index < 42; index += 1) {
      var piece = document.createElement('i');
      piece.style.setProperty('--x', (Math.random() * 100).toFixed(2) + 'vw');
      piece.style.setProperty('--delay', (Math.random() * 0.5).toFixed(2) + 's');
      piece.style.setProperty('--color', ['#ff3d81', '#ffcb3d', '#55d98b', '#6f5cff', '#39bdf8'][index % 5]);
      layer.appendChild(piece);
    }
    document.body.appendChild(layer);
    window.setTimeout(function() { layer.remove(); }, 2600);
    this.announce(detail === 'Cadoul a fost revendicat!' ? 'Cadoul a fost revendicat!' : 'Cadoul a fost revendicat! ' + detail, false);
  };

  GiftBar.prototype.renderHall = function() {
    var members = this.state.hallOfFame || [];
    if (!members.length) {
      this.hall.hidden = true;
      return;
    }
    this.hall.hidden = false;
    this.hall.innerHTML = '<header><span aria-hidden="true">🏆</span><h2>Hall of Fame</h2></header><div class="faima-hall-grid">' + members.map(function(member, index) {
      return '<article><span class="faima-hall-rank">#' + (index + 1) + '</span><span class="faima-hall-avatar" aria-hidden="true">👑</span><strong>@' + escapeHtml(member.username) + '</strong><small>' + Number(member.purchasedFollowers || 0).toLocaleString('ro-RO') + ' urmăritori</small></article>';
    }).join('') + '</div>';
  };

  function initialize() {
    if ((document.documentElement.lang || '').toLowerCase().indexOf('es') === 0) return;
    ensureGiftStylesheet();
    document.querySelectorAll('[data-faima-checkout]').forEach(function(root) {
      if (root.dataset.faimaGiftsInitialized === 'true') return;
      root.dataset.faimaGiftsInitialized = 'true';
      new GiftBar(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
